"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mobile_1 = require("@alfalab/core-components/modal/mobile");
const index_module_css_1 = __importDefault(require("./index.module.css"));
const Wrapper = ({ children, fullScreen }) => {
    if (fullScreen) {
        return ((0, jsx_runtime_1.jsx)(mobile_1.ModalMobile, { open: true, dataTestId: 'full-screen-wrapper', children: (0, jsx_runtime_1.jsx)(mobile_1.ModalMobile.Content, { className: index_module_css_1.default.fullHeight, children: children }) }));
    }
    return children;
};
exports.Wrapper = Wrapper;
